// These are the rules by which the form input fields will be checked against.

import dayjs from "dayjs";

import { getValue, isYoutube } from "../shared/miscUtils";
import { formHasErrors, formHasValue, setFormValues } from "./objectValidation";

import { RESOURCE_TYPES } from "../../config/constants/Constants";

/**
 * Criteria:
 * 1) Required if URL not about YouTube
 */
const nameValidation = (prevConfig, row, value) => {
    const url = getValue(row, "url");

    // 1)
    if (!isYoutube(url) && value.trim() === "") {
        return setFormValues(row, "name", true, "Required");
    }

    return setFormValues(row, "name", false, "");
};

/**
 * Criteria:
 * 1) Required
 * 2) Must be a valid url
 */
const urlValidation = (prevConfig, row, value) => {
    if (value === null) {
        return setFormValues(row, "url", false, "");
    }

    // 1)
    if (value === "") {
        return setFormValues(row, "url", true, "Required");
    }

    // 2)
    if (!/^(http|https):\/\/[^ "]+$/.test(value)) {
        return setFormValues(row, "url", true, "Invalid URL");
    }

    return setFormValues(row, "url", false, "");
};

/**
 * Criteria:
 * 1) Required
 * 2) Must be from a valid type
 */
const typeValidation = (prevConfig, row, value) => {
    // 1)
    if (value === "") {
        return setFormValues(row, "type", true, "Required");
    }

    // 2)
    if (!RESOURCE_TYPES.includes(value)) {
        return setFormValues(row, "type", true, "Invalid type");
    }

    return setFormValues(row, "type", false, "");
};

/**
 * Criteria:
 * 1) Optional
 * 2) Must be valid
 * 3) Must be in the past
 */
const uploadedOnValidation = (prevConfig, row, value) => {
    // 1)
    if (value === "" || value === null) {
        return setFormValues(row, "uploaded_on", false, "");
    }

    // 2)
    if (!dayjs(value).isValid()) {
        return setFormValues(row, "uploaded_on", true, "Invalid");
    }

    // 3)
    if (dayjs(value).isAfter(dayjs())) {
        return setFormValues(row, "uploaded_on", true, "Must be in the past");
    }

    return setFormValues(row, "uploaded_on", false, "");
};

// The main constant, directing to the specific validation function.
export const RESOURCE_VALIDATION = {
    name: {
        check: nameValidation
    },
    url: {
        check: urlValidation
    },
    type: {
        check: typeValidation
    },
    uploaded_on: {
        check: uploadedOnValidation
    }
};

export const IS_RESOURCE_VALID = (obj) => {
    return !formHasErrors(obj) && formHasValue(obj, "type") && formHasValue(obj, "url");
};
